<template>
    <div class='gradeAdd'>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-row type="flex" justify="space-between" :gutter="20" class="elRow">
                <el-col >
                    <el-form-item label="学期：" prop="grade">
                        <el-select v-model="ruleForm.grade" placeholder="请选择" @change="onGenderChange">
                            <el-option v-for="(item,index) in gradeList" :label="item.label" :value="item.value" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item  label="考试：" prop="name">
                        <el-select v-model="ruleForm.name" placeholder="请选择">
                            <el-option v-for="(item,index) in testName" :label="item.label" :value="item.value" :key="index" :disabled="item.disabled"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item  label="年级人数：" prop="totalPeople">
                        <el-input type="number" v-model="ruleForm.totalPeople" placeholder="请填写" @input="onTotalPeopleChange"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="选考科目：" prop="subjects" label-width="95px">
                <el-checkbox-group v-model="ruleForm.subjects" :max="3" @change="onSubjectChange">
                    <el-checkbox v-for="(item,index) in selectSubjects" :label="item.subject" name="subjects" :value="item.subject" :key="index"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <p class='tips'>（学科分数请输入正整数）</p>
            <table class="gradeTable">
                <thead>
                    <tr>
                        <th width='130'>科目</th>
                        <th width='100'>分数</th>
                        <th width='100'>年级人数</th>
                        <th width='100'>单科排名</th>
                        <th width='120'>年级总排名</th>
                        <th>考试说明</th>
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(item,index) in ruleForm.subject">
                        <td width='130' >
                            {{item.subject}}
                        </td>
                        <td width='100'>
                            <el-input v-model="ruleForm.subject[index].score"  type="number"></el-input>
                        </td>
                        <td width='100'>
                            <el-input v-model="ruleForm.subject[index].totalPeople"  type="number"></el-input>
                        </td>

                        <td width='100'>
                            <el-input v-model="ruleForm.subject[index].rank"  type="number"></el-input>
                        </td>
                        <td width='120'  :rowspan="ruleForm.subject.length" v-if="index==0">
                            <el-input  type="number" v-model="ruleForm.totalRank" :style="{height: ruleForm.subject.length*41+'px'}"></el-input>
                        </td>
                        <td>
                            <el-input v-model="ruleForm.subject[index].remark"></el-input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="summary">
                <p class="summaryTitle">
                    <span class="no1 block"></span>
                    <span class="no2 block"></span>
                    <span class="no3 block"></span>
                    <span class="name">考试总结</span>
                    <span class="no3 block"></span>
                    <span class="no2 block"></span>
                    <span class="no1 block"></span>
                </p>
                <el-form-item  prop="remark">
                    <el-input  type="textarea" v-model="ruleForm.remark" placeholder="请填写考试总结"  :rows="5" ></el-input>
                </el-form-item>
            </div>

            <div class="nextPointSubject">
                <div class="title">
                    下一阶段重点提升学科
                    <p class="tips" :style="{paddingLeft:'10px'}">
                    （最多选择5个学科）
                    </p>
                </div>
                <el-form-item>
                    <el-checkbox v-model="item.important"  :true-label="1" :false-label="0"  :value="item.important"  v-for="(item,index) in ruleForm.subject" :label="item.subject"  :key="index"  :disabled="getDisabled(item.important)"></el-checkbox>
                </el-form-item>
            </div>
        </el-form>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
<!--            <Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" name="预览" ></Button>-->
            <Button @handleClick="submitForm('ruleForm',false)" :type="'btnBlue'" name="保存" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
export default {
    name: "gradeAdd",
    components: {
        Button
    },
    data() {
        return {
            subjectImportant: [],
            isCanCheck: true,
            province: sessionStorage.getItem('myStudentProvince'),//学生省份
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            gradeList: [
                { label: '初一上学期', value: '1' },
                { label: '初一下学期', value: '2' },
                { label: '初二上学期', value: '3' },
                { label: '初二下学期', value: '4' },
                { label: '初三上学期', value: '5' },
                { label: '初三下学期', value: '6' },
                { label: '中考', value: 'middle' },
                { label: '高一上学期', value: '7' },
                { label: '高一下学期', value: '8' },
                { label: '高二上学期', value: '9' },
                { label: '高二下学期', value: '10' },
                { label: '高三上学期', value: '11' },
                { label: '高三下学期', value: '12' },
            ],
            allSubjects: [
                { subject: '语文',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '数学',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '外语',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '物理',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '化学',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '生物',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '历史',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '地理',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '政治',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                // { subject: '技术',score: '',rank: '',remark: '', totalPeople: '',important: '0'}
            ],
            selectSubjects: [
                { subject: '物理',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '化学',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '生物',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '历史',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '地理',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                { subject: '政治',score: '',rank: '',remark: '', totalPeople: '',important: '0'},
                // { subject: '技术',score: '',rank: '',remark: '', totalPeople: '',important: '0'}
            ],
            testName: [
                { label: '第一次月考', value: '1', disabled: false },
                { label: '第二次月考', value: '2', disabled: false },
                { label: '第三次月考', value: '3', disabled: false },
                { label: '第四次月考', value: '4', disabled: false },
            ],
            ruleForm: {
                grade: '',//学期
                name: '',//考试名称
                totalPeople: '',//总人数
                totalRank: '',//年级总排名
                remark: '',//考试总结
                subjects: [],//选考科目
                subject: [],
            },
            rules: {
                grade: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                name: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                totalPeople: [
                    { required: true, message: '请填写', trigger: 'blur' },
                ],
                remark: [
                    { required: true, message: '请填写考试总结', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        if(this.province!= '浙江') {
            this.ruleForm.subject = this.allSubjects;
        }else {
            this.allSubjects.push({ subject: '技术',score: '',rank: '',remark: '', totalPeople: '',important: '0'})
            this.selectSubjects.push({ subject: '技术',score: '',rank: '',remark: '', totalPeople: '',important: '0'})
            this.ruleForm.subject = this.allSubjects;

        }
    },
    methods: {
        changImportant(val) {
            console.log(val)
        },
        onGenderChange(value) {
            console.log(value)
            let [...allSubjects1] = this.allSubjects;
            let totalPeople = this.totalPeople;
            this.getNameByStudentIdAndGrade(value);
            if(Number(value)>2&&Number(value)<7) {
                let arr1 = this.allSubjects.slice(0,3);
                let arr2 = [];
                let subjects = this.ruleForm.subjects;
                if(subjects.length > 0) {
                    arr2 = this.selectSubjects.filter((value,index) =>{
                        return subjects.includes(value.subject);
                    })
                }
                arr1 = arr1.concat(arr2);
                if(totalPeople>0) {
                    arr1[0].totalPeople = totalPeople;
                    arr1[1].totalPeople = totalPeople;
                    arr1[2].totalPeople = totalPeople;
                    this.ruleForm.subject = arr1;
                    this.ruleForm.totalPeople = totalPeople;
                }else {
                    this.ruleForm.subject = arr1;
                }

            }else {
                if(totalPeople>0) {
                    allSubjects1.forEach((val)=>{
                        val.totalPeople = totalPeople;
                    })
                    this.ruleForm.subject = allSubjects1;
                    this.ruleForm.totalPeople = totalPeople;
                }else {
                    this.ruleForm.subject = allSubjects1;
                }

            }
        },
        onSubjectChange(value) {
            let subjects = value;
            let [...arr] = this.ruleForm.subject;
            let arr1 = arr.slice(3);
            let arr2 = arr.slice(0,3);
            // console.log(arr1,arr2,subjects)
            if(subjects.length > arr1.length) {
                this.selectSubjects.forEach((value) =>{
                    if(value.subject == subjects.slice(-1)) {
                        arr1.push(value);
                        arr2 = arr2.concat(arr1)
                    }
                })
            }else {
                arr1.forEach((value) =>{
                    if(subjects.includes(value.subject)) {
                        arr2.push(value)
                    }
                })
            }
            this.ruleForm.subject = arr2;
        },
        onTotalPeopleChange(value){
            let grade = this.grade;
            let [...subject] = this.ruleForm.subject;
            if(grade==1||grade==2) {
                subject.forEach((val)=>{
                    val.totalPeople = value;
                })
            }else {
                subject[0].totalPeople = value;
                subject[1].totalPeople = value;
                subject[2].totalPeople = value;
            }
            this.ruleForm.subject = subject;

        },
        getNameByStudentIdAndGrade(grade){
            let testName1 = [
                { label: '第一次月考', value: '1', disabled: false },
                { label: '第二次月考', value: '2', disabled: false },
                { label: '第三次月考', value: '3', disabled: false },
                { label: '第四次月考', value: '4', disabled: false },
            ];
            let studentId  = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.getNameByStudentIdAndGrade, {
                grade:grade,
                studentId: studentId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let data = res.data.data;
                    data.forEach((value)=>{
                        testName1.forEach((val)=>{
                            if(value.name==val.value) {
                                val.disabled = true;
                            }
                        })
                    })
                    this.testName = testName1;
                }
            })
        },
        getLastPeopleNumByStudentId(grade){
            let studentId  = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.getLastPeopleNumByStudentId, {
                studentId: studentId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let totalPeople = res.data.data.totalPeople;
                    if(totalPeople>0) {
                        this.totalPeople = totalPeople;
                    }
                }
            })
        },
        getDisabled(important) {
            let subject = this.ruleForm.subject;
            let num = 0;
            subject.forEach((item)=>{
                num+=Number(item.important);
            })
            // console.log(num,important)
            if(num>4&&important!=1) {
                return true;
            }else {
                return false;
            }
        },
        submitForm(formName) {
            console.log(this.ruleForm)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const obj = {...this.ruleForm};
                    console.log(this.ruleForm)
                    obj.studentId = this.studentId;
                    this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.storeAchievement, obj, {
                        headers: {
                            token: window.sessionStorage.getItem('ymtxToken')
                        }
                    }).then((res) => {
                        if (res.data.code == 2000) {
                            let id = res.data.data.id;
                            this.$router.push({path:'/consultant/minestudent/main/studentMessage/grade/detail',query:{id: id}})
                        }
                    })

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
}
</script>
<style scoped lang="less">
.gradeAdd {
    color: #333;
    padding-bottom: 40px;
    font-size: 16px;
    .demo-ruleForm {
        padding: 0 30px;
        background-color: #fff;
    }
    .summaryTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        height: 28px;
        font-weight: bold;
        margin-bottom: 10px;
        .name {
            padding: 0 3px;
        }
        .block {
            display: block;
            width: 8px;
            height: 8px;
            margin: 0 6px;
            border-radius: 4px;
        }
        .no1 {
            background: rgba(92, 92, 92, 0.3);
        }
        .no2 {
            background: rgba(92, 92, 92, 0.7);
        }
        .no3 {
            background: #5C5C5C;
        }
    }
    .ant-input-number-handler-wrap {
        width: 0px;
    }
    .ant-form-item-control-input {
        min-height: 0px;
    }
    .tips {
        font-size: 14px;
        line-height: 30px;
        color: #ABABAB;
    }
    .contentBox {
        padding: 0 20px 30px 20px;
        background-color: #fff;
    }
    .line {
        //margin-bottom: 20px;
    }
    .ant-form-item {
        margin: 0;
    }
    .gradeTable {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
        input {
            border: none;
            line-height: 40px;
            text-align: center;
            padding-top: 0px;
            padding-bottom: 0px;
        }
        thead {
            background: rgba(61, 144, 246, 0.2);
            color: #333;
            th {
                border: 1px solid rgba(61, 144, 246, 0.4);
            }
        }
        tbody {
        }
        tr {
            border: 1px solid rgba(61, 144, 246, 0.4);
        }
        td {
            border: 1px solid rgba(61, 144, 246, 0.4);
            line-height: 40px;
        }
        td:first-child{
            background: #FAFDFF;
        }
        th {
            font-size: 16px;
            line-height: 40px;
            text-align: center;
        }
    }
    .summary {
        padding: 20px 0px;
        .summaryTitle {
            margin-bottom: 20px;
        }
        .area {
            font-size: 16px;
            line-height: 26px;
            min-height: 128px;
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
            border: none;
            padding: 15px;
        }
    }
    .nextPointSubject {
        padding: 20px 0px;
        // margin-bottom: 30px;
        .title {
            font-size: 20px;
            font-weight: 500;
            color: #333;
            line-height: 28px;
            margin-bottom: 20px;
            display: flex;
            .tips {
                font-size: 14px;
            }
        }
    }
    .subject {
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        margin-bottom: 22px;
    }
    .totalScore {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 25px;
    }
    .point {
        padding-top: 15px;
        .title {
            height: 28px;
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 12px;
            font-weight: bold;
        }
    }
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>
<style lang="less">
.gradeAdd {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .elRow {
        .el-form-item {
            display: flex;
            .el-form-item__content {
                flex: 1;
                margin-left: 0 !important;
            }
        }
    }
    table {
        .el-input {
            line-height: 40px;
            height: 40px;
        }
        input {
            height: 100%;
            line-height: 40px;
            border: none;
        }
        td {
            .el-input__inner {
                border: none;
            }
        }
    }

}
</style>